<template>
  <div class="AvisoPrivacidad not-container">
    <div class="container-fluid" style="padding: 0px; height: 70vh;">
      <div class="hero-image">
        <div class="hero-text">
          <h1 style="font-size: 50px; color: rgb(255, 255, 255);">
            AVISO DE PRIVACIDAD
          </h1>
        </div>
      </div>
    </div>
    <section class="container wow fadeIn pt-5 pb-5">
      <div class="container privacity_zone">
        <div class="row flex-column text-justify">
          <h1>Introducción</h1>
          <p class="privacity_p">
            Su información personal será utilizada para proveer información sobre las actividades de facturación, servicios solicitados, informarle sobre nuevas funciones, servicios o cambios en los mismos, mensajes promocionales y evaluar la calidad del servicio que le brindamos, mismos que le haremos llegar vía telefónica, electrónica, o por cualquier otra tecnología o medio que esté al alcance de HOOCH.
          </p>
          <h2>Identificación del Responsable</h2>
          <p class="privacity_p">
            AGROKLAY S.A. DE C.V. con domicilio en Calle Libra 356 piso 1, en la colonia Juan Manuel Vallarta, Zapopan, Jalisco, México, C.P. 45120, es responsable del tratamiento de sus datos personales.
          </p>
          <h2>Finalidad del tratamiento</h2>
          <p class="privacity_p">
            Para las finalidades antes mencionadas, requerimos obtener los siguientes datos personales: Nombre, domicilio, número telefónico, correo electrónico, registro federal de contribuyentes, así como, cualquier otra información de cualquier otra índole, siempre que se cumpla con lo establecido en la “Ley” y su Reglamento respecto a cada tipo de información, mismos, que quedarán registrados en nuestra base de datos; sin que ninguna de esta información sea considerada como Datos Sensibles en los términos señalados en la Fracción VI del Artículo 3ro. de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares. HOOCH, se compromete con su obligación de guardar sus datos personales, durante el tiempo necesario para cumplir con la finalidad para lo cual fueron solicitados.
          </p>
         
          
           
            <h2>Datos sensibles</h2>
            <p class="privacity_p">
              Por regla general, no recabamos datos sensibles, entendiéndose
              como tales aquellos que afectan a su esfera más íntima, o cuyo uso
              indebido de nuestra parte pueda dar origen a discriminación o
              conlleve un riesgo para usted. En particular se considerarán
              sensibles aquellos datos que puedan revelar aspectos sobre su
              origen racial o étnico, su estado de salud presente o futura, su
              información genética, sus creencias religiosas, filosóficas o
              morales, su afiliación sindical, sus opiniones políticas o su
              preferencia sexual.
            </p>
            
            <h2 class="mt-2">Derechos ARCO</h2>
            <h4>¿Cómo puede ejercer sus derechos ARCO?</h4>
            <p class="privacity_p">
                Usted tiene derecho de acceder, rectificar y cancelar sus datos personales, así como de oponerse al tratamiento de los mismos o revocar el consentimiento que para tal fin nos haya otorgado, derecho que puede hacer valer en todo momento. Para ejercer ese derecho envíe su solicitud mediante una nota electrónica al correo <a href="mailto:info@hooch.com.mx">info@hooch.com.mx</a>.
                <br />
                <strong>Su petición deberá ir acompañada de la siguiente información;</strong>
                <ul class="not-dot">
                    <li>(1) nombre del titular, correo electrónico y teléfono para comunicarle la respuesta,</li>
                    <li>(2) documento que acredite la identidad del titular, o en su caso, la representación del mismo,</li>
                    <li>(3) descripción clara y precisa de los datos personales respecto de los cuales se pretende ejercer el derecho y </li>
                    <li>(4) cualquier otro elemento o documento que facilite la localización del dato personal.</li>
                </ul>
            </p>
            <p class="privacity_p">
              Cualquier modificación a este aviso de privacidad podrá consultarla en este mismo medio.
            </p>
          
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AvisoPrivacidad"
};
</script>

<style lang="scss" scoped>
.AvisoPrivacidad {
  text-align: center;

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th {
    border: 1px solid black;
    text-align: justify;

    &:first-of-type {
      min-width: 310px;
      @media screen and (max-width: 425px) {
        min-width: 100px;
      }
    }
  }

  td {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr {
    background-color: #dddddd;
  }

  @media screen and (max-width: 425px) {
    .row {
      margin: auto;
      text-align: center !important;

      h1 {
        text-align: center;
        margin: auto;
      }
    }
  }

  .hero-image {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url("../assets/images/hooch.jpeg");
    height: 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  .hero-text {
    padding-top: 15rem;
    margin: auto;
    text-align: center;
  }
  ul.not-dot{
    list-style: none;
    padding-left: 20px;
  }
}
</style>
